import React from 'react';

type IconProps = {
  className?: string;
};

/**
 * Icono "maximize" (Lucide `maximize`, ISC) — las cuatro esquinas abriéndose
 * hacia fuera, glifo estándar de "pantalla completa" en reproductores y mapas.
 * Inline con `stroke="currentColor"` para heredar el color del contenedor
 * (color PRIMARY del tema), igual que LayersIcon/LocateIcon: un `<img>` no
 * hereda color y la máscara CSS falla con las URLs de assets de Vite.
 */
export const MaximizeIcon = ({ className }: IconProps): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M8 3H5a2 2 0 0 0-2 2v3" />
      <path d="M21 8V5a2 2 0 0 0-2-2h-3" />
      <path d="M3 16v3a2 2 0 0 0 2 2h3" />
      <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
    </svg>
  );
};
